import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@material-ui/core";
import _ from "lodash";

import withAuthority from "../../../../components/Auth/withAuthority";
import Authorities from "../../../../auth/authorities";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { useRouteMatch } from "react-router";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import { fetchAllFilterLocations } from "../../../../services/locationApp/locationFilterService";
import { getCookie } from "../../../../utils/cookies";
import VoidSummeryInfoNode from "./VoidSummeryInfoNode";
import { voidSummeryFilterObject } from "../../../../utils/consts/list";
import { CustomTheme } from "../../../../types/customTheme";
import SaleReport from "../../../../components/common/SaleReport";
import { getFilterListFromArrayObject } from "../../../../utils/commonArrayMap";
import { fetchAllVoidSummeryInfo } from "../../../../services/salesApp/voidSummeryServices";
import { fetchAllVGetLogsInfo } from "../../../../services/salesApp/logsService";
import FilterOption from "./FilterOption";
import { fetchAllUserInfo } from "../../../../services/salesApp/salesService";

/**
 * LogsPage Component:
 *
 * This component is responsible for displaying the VAT summary report for void transactions.
 * It retrieves void summary information from the backend API based on the selected filters
 * such as location, date range, etc., and presents the data in a tabular format.
 */
const LogsPage: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [orderId, setOrderId] = useState("");
  const [logsNode, setLogsNode] = useState([]);
  const [genericNode, setGenericsNode] = useState([]);
  const [kdsLogs, setKdsLogs] = useState([]);
  const [userDetails, setUserDetails] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [locationSelectorList, setLocationSelectorList] = useState([]);
  const [isGeneric, setIsGeneric] = useState(false);
  const [isKdsLogs, setIsKdsLogs] = useState(false);
  const match: any = useRouteMatch();
  const idToken = getCookie("idToken");

  const handleGetLogsInfoGeneric = async () => {
    setIsLoading(true);
    try {
      const res: any = await fetchAllVGetLogsInfo(
        match.params.locationId,
        "generic",
      );
      setGenericsNode(res.data.data);
      setLogsNode(res.data.data);
      setIsLoading(false);
      setIsGeneric(true);
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };

  const handleGetLogsInfoKds = async () => {
    setIsLoading(true);
    try {
      const res: any = await fetchAllVGetLogsInfo(
        match.params.locationId,
        "kds",
      );
      setKdsLogs(res.data.data);
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };

  const getUserInfo = async () => {
    try {
      const res = await fetchAllUserInfo(idToken, match.params.locationId);
      setUserDetails(res.data.data);
      getAllFilterLocation([match.params.locationId]);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };
  const handleGetLogsInfos = async () => {
    setIsLoading(true);
    try {
      const id = orderId.replace(".", "_");
      const res: any = await fetchAllVGetLogsInfo(match.params.locationId, id);
      setLogsNode(res.data.data);
      setIsLoading(false);
      setIsGeneric(false);
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };

  const getAllFilterLocation = async (searchName: any) => {
    fetchAllFilterLocations("")
      .then((res) => {
        let locationList: any = [];
        /* Setting up the list of locations as needed to select locations. */
        if (!_.isEmpty(res.data.data)) {
          res.data.data.map((location: any) =>
            locationList.push({
              id: location.id,
              label: location.businessDisplayName,
            }),
          );
        }
        handleGetLogsInfoGeneric();
        handleGetLogsInfoKds();
        setLocationSelectorList(locationList);
      })
      .catch(() => {
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      });
  };

  useEffect(() => {
    document.title = "Sale - Logs";
    setIsLoading(true);
    getUserInfo();
  }, []);
  const handleSubmitGeneric = () => {
    setIsGeneric(true);
    setLogsNode(genericNode);
  };

  const handleSubmitKds = () => {
    setIsGeneric(true);
    setLogsNode(kdsLogs);
  };
  const theme: CustomTheme = useTheme();
  return (
    <>
      <Box>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", cursor: "pointer", marginTop: "16px" }}
          color="secondary"
          align="left"
        >
          Logs
        </Typography>
        <FilterOption
          orderId={orderId}
          setOrderId={setOrderId}
          handleGetLogsInfo={handleGetLogsInfos}
          handleSubmitGeneric={handleSubmitGeneric}
          handleSubmitKds={handleSubmitKds}
        />
        <VoidSummeryInfoNode
          logsNode={logsNode}
          userDetails={userDetails}
          isLoading={isLoading}
          locationSelectorList={locationSelectorList}
          isGeneric={isGeneric}
        />
        <DefaultAlert
          open={!!error}
          handleClose={() => setError("")}
          message={error}
          severity="error"
        />
      </Box>
    </>
  );
};

export default withAuthority(LogsPage, Authorities.SALE_READ);
